(() => {
  const addSwiperStructure = (slider) => {
    const wrapper = slider.querySelector('.multicolumn-list__wrapper');
    const items = slider.querySelectorAll('.multicolumn-list__item');

    slider.classList.add('swiper');
    if (wrapper) {
      wrapper.classList.add('swiper-wrapper');
    }

    items.forEach((item) => {
      item.classList.add('swiper-slide');
    });
  };

  const removeSwiperStructure = (slider) => {
    const wrapper = slider.querySelector('.multicolumn-list__wrapper');
    const items = slider.querySelectorAll('.multicolumn-list__item');

    slider.classList.remove('swiper');
    if (wrapper) {
      wrapper.classList.remove('swiper-wrapper');
    }

    items.forEach((item) => {
      item.removeAttribute('style');
      item.classList.remove('swiper-slide');
    });
  };

  const detachWheelScroll = (slider) => {
    if (!slider) {
      return;
    }

    if (slider.__mcWheelRelease) {
      slider.__mcWheelRelease();
      slider.__mcWheelRelease = null;
    }

    if (slider.__mcWheelHandler) {
      slider.removeEventListener('wheel', slider.__mcWheelHandler);
      slider.__mcWheelHandler = null;
    }
  };

  const attachWheelScroll = (slider, swiperInstance) => {
    if (!slider || !swiperInstance) {
      return;
    }

    detachWheelScroll(slider);

    const defaultSpeed = Number(swiperInstance.params && swiperInstance.params.speed) || 800;
    const wheelSpeed = Math.min(defaultSpeed, 450);
    const deltaThreshold = 25;

    let deltaBuffer = 0;
    let wheelLocked = false;
    let pendingUnlock = null;

    const handleWheel = (event) => {
      const hasHorizontalIntent = Math.abs(event.deltaX) >= Math.abs(event.deltaY);
      const delta = hasHorizontalIntent ? event.deltaX : event.shiftKey && !event.deltaX ? event.deltaY : 0;

      if (!delta) {
        return;
      }

      if (event.cancelable) {
        event.preventDefault();
      }

      deltaBuffer += delta;

      if (wheelLocked || swiperInstance.animating) {
        deltaBuffer = 0;
        return;
      }

      if (Math.abs(deltaBuffer) < deltaThreshold) {
        return;
      }

      const direction = deltaBuffer > 0 ? 1 : -1;
      const canAdvance = direction > 0 ? !swiperInstance.isEnd : !swiperInstance.isBeginning;

      deltaBuffer = 0;

      if (!canAdvance) {
        return;
      }

      wheelLocked = true;
      swiperInstance.params.speed = wheelSpeed;

      const unlock = () => {
        if (pendingUnlock !== unlock) {
          return;
        }

        swiperInstance.off('slideChangeTransitionEnd', unlock);
        swiperInstance.params.speed = defaultSpeed;
        wheelLocked = false;
        pendingUnlock = null;
      };

      pendingUnlock = unlock;
      swiperInstance.on('slideChangeTransitionEnd', unlock);
      swiperInstance[direction > 0 ? 'slideNext' : 'slidePrev']();
    };

    slider.__mcWheelHandler = handleWheel;
    slider.addEventListener('wheel', handleWheel, { passive: false });

    slider.__mcWheelRelease = () => {
      if (pendingUnlock) {
        swiperInstance.off('slideChangeTransitionEnd', pendingUnlock);
        pendingUnlock = null;
      }

      swiperInstance.params.speed = defaultSpeed;
      wheelLocked = false;
      deltaBuffer = 0;
    };
  };

  const slidesPerGroupFor = (value) => Math.max(1, Math.floor(value));

  const initSlider = (section) => {
    const slider = section.querySelector('.swiper--multicolumn:not(.swiper-initialized)');
    if (!slider) {
      return;
    }

    addSwiperStructure(slider);

    const mobileColumns = parseFloat(slider.dataset.mobileColumns) || 1;
    const desktopColumns = parseFloat(slider.dataset.desktopColumns) || 1;
    const laptopColumns = desktopColumns >= 4 ? desktopColumns - 1 : desktopColumns;
    const tabletColumns = desktopColumns > 2 ? Math.max(1, laptopColumns - 1) : desktopColumns;

    const swiperInstance = new Swiper(slider, {
      loop: false,
      speed: 800,
      slidesPerView: mobileColumns,
      slidesPerGroup: slidesPerGroupFor(mobileColumns),
      spaceBetween: 8,
      breakpoints: {
        750: {
          slidesPerView: tabletColumns,
          slidesPerGroup: slidesPerGroupFor(tabletColumns),
          spaceBetween: 24
        },
        990: {
          slidesPerView: laptopColumns,
          slidesPerGroup: slidesPerGroupFor(laptopColumns),
          spaceBetween: 24
        },
        1360: {
          slidesPerView: desktopColumns,
          slidesPerGroup: slidesPerGroupFor(desktopColumns),
          spaceBetween: 24
        }
      },
      pagination: {
        el: slider.querySelector('.multicolumn__pagination'),
        clickable: false,
        type: 'custom',
        renderCustom(swiper, current, total) {
          let bullets = '';
          for (let index = 1; index < total + 1; index += 1) {
            const isActive = index === current ? ' swiper-pagination-bullet-active' : '';
            bullets += `<span class="swiper-pagination-bullet${isActive}" tabindex="0" role="button" aria-label="Go to slide ${index}"></span>`;
          }
          return bullets;
        }
      }
    });

    attachWheelScroll(slider, swiperInstance);
  };

  const destroySlider = (section) => {
    const slider = section.querySelector('.swiper--multicolumn');
    if (!slider) {
      return;
    }

    detachWheelScroll(slider);

    if (slider.swiper) {
      slider.swiper.destroy();
    }

    removeSwiperStructure(slider);
  };

  const hydrateSection = (section) => {
    if (!section || !section.classList.contains('multicolumn-section')) {
      return;
    }

    const slider = section.querySelector('.swiper--multicolumn');

    if (!slider) {
      return;
    }

    new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        const shouldToggle = slider.dataset.sliderMobile !== 'true' || slider.dataset.sliderDesktop !== 'true';
        const isMobile = entry.contentRect.width < 576;
        const shouldInit = shouldToggle
          ? isMobile
            ? slider.dataset.sliderMobile === 'true'
            : slider.dataset.sliderDesktop === 'true'
          : true;

        (shouldInit ? initSlider : destroySlider)(entry.target);
      });
    }).observe(section);
  };

  hydrateSection(document.currentScript.parentElement);

  document.addEventListener('shopify:section:load', (event) => {
    hydrateSection(event.target);
  });
})();
